export default ({ request }) => ({
  sampleStockBorrowListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/list',
      method: 'post',
      data
    })
  },
  sampleBorrowDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/detail',
      method: 'post',
      data
    })
  },
  sampleBorrowSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/save',
      method: 'post',
      data
    })
  },
  sampleBorrowDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/del',
      method: 'post',
      data
    })
  },
  sampleBorrowAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBorrowMain/audit',
      method: 'post',
      data
    })
  }
})
